// @flow
import { handleActions } from 'redux-actions';
import { remove } from 'lodash';
import {
    ADD_ALERT, ADD_CONFIRM, REMOVE_ALERT, REMOVE_CONFIRM,
} from './constants';


export type AlertDialog = {
    +title: ?string,
    +message: string,
    +executionId: string,
    +actionLabel: ?string,
    +size: ?string,
    +key: string,
};

export type ConfirmDialog = {
    +title: ?string,
    +message: ?string,
    +actions: {
        [string]: {
            +label: string,
            +type?: 'positive' | 'negative',
        }
    },
    +executionId: string,
    +key: string,
    +size: ?string,
    [string]: any,
};

export type State = {
    +alerts: Array<AlertDialog>,
    +confirms: Array<ConfirmDialog>,
};


const initialState: State = {
    alerts: [],
    confirms: [],
};

let alertTotalCount = 0;

const reducer = handleActions({
    [ADD_ALERT]: (state: State, { payload }: {
        payload: {
            title: ?string,
            message: string,
            executionId: string,
            size: ?string,
        }
    }) => {
        const {
            title, message, executionId, size,
        } = payload;
        alertTotalCount += 1;


        return {
            ...state,
            alerts: [
                ...state.alerts, {
                    title, message, executionId, key: alertTotalCount, size,
                },
            ],
        };
    },
    [ADD_CONFIRM]: (state: State, { payload }: {
        payload: {
            title: ?string,
            message: string,
            executionId: string,
            key: string,
            actions: {
                [string]: {
                    label: string,
                    type?: 'positive' | 'negative',
                }
            },
            size: ?string,
        }
    }) => ({
        ...state,
        confirms: [...state.confirms, payload],
    }),
    [REMOVE_ALERT]: (state: State, { payload }: {
        payload: string,
    }) => {
        let { alerts } = state;
        alerts = [...alerts];

        remove(alerts, (a) => a.key === payload);

        return {
            ...state,
            alerts,
        };
    },
    [REMOVE_CONFIRM]: (state: State, { payload }: {
        payload: string,
    }) => {
        let { confirms } = state;
        confirms = [...confirms];

        remove(confirms, (c) => c.key === payload);

        return {
            ...state,
            confirms,
        };
    },
}, initialState);

export default reducer;
